import { useEffect, useState } from 'react';
import { SimulatePlanChangeAPI } from '../../../api/API';

/**
 * Prévia do Stripe da troca para `planId` (aplicada agora, com proração):
 * charge_now_cents (plano maior), credit_cents e next_charge_cents (plano menor)
 * e next_due_date. Só consulta com `enabled`. Sem prévia, simulation fica null.
 */
const usePlanChangeSimulation = (planId, enabled = true) => {
  const [simulation, setSimulation] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !planId) return undefined;
    let active = true;
    setSimulation(null);
    setLoading(true);
    SimulatePlanChangeAPI(planId, true, 'now', (result) => {
      if (!active) return;
      setLoading(false);
      setSimulation(result?.success ? result.simulation || null : null);
    });
    return () => { active = false; };
  }, [planId, enabled]);

  return { simulation, loading };
};

export default usePlanChangeSimulation;
